import { useIntl } from "react-intl";

import { CtaModal } from "ui/CtaModal";
import { BodyM } from "ui/Typography/Typography";

export function OverMaximumWarningModal({
  exceedAmount,
  maxAllowedTotal,
  onClose,
}: {
  exceedAmount: number;
  maxAllowedTotal: number;
  onClose: () => void;
}) {
  const intl = useIntl();
  return (
    <CtaModal
      isOpen
      onClose={() => {}}
      hideCloseButton
      onClickCta={onClose}
      title={intl.formatMessage({
        id: "components.over-maximum-warning-modal.title",
      })}
      ctaLabel={intl.formatMessage({ id: "generic.actions.back" })}
      body={
        <BodyM textAlign="center">
          {intl.formatMessage(
            { id: "components.over-maximum-warning-modal.description" },
            { exceedAmount, maxAllowedTotal },
          )}
        </BodyM>
      }
      variant="secondary"
    />
  );
}
